import { render, staticRenderFns } from "./OverlayLoginRegister.vue?vue&type=template&id=1ec59dd1&"
import script from "./OverlayLoginRegister.vue?vue&type=script&lang=js&"
export * from "./OverlayLoginRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec59dd1')) {
      api.createRecord('1ec59dd1', component.options)
    } else {
      api.reload('1ec59dd1', component.options)
    }
    module.hot.accept("./OverlayLoginRegister.vue?vue&type=template&id=1ec59dd1&", function () {
      api.rerender('1ec59dd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/OverlayLoginRegister.vue"
export default component.exports